<template>
  <div class="holeHome">
    <div class="fzmBanner-home">
      <img src="@/assets/img/Image 9.png" alt="">
    </div>

    <div class="fzmDonutSection">
      <template v-for="(flavor, index) in flavors">

        <donut-right :key="index" :donut="flavor" v-if="!isOdd(index)"/>
        <donut-left :key="index" :donut="flavor" v-else/>
        
      </template>

    </div>
  </div>
</template>

<script>

// components
import donutLeft from '@/components/donutSectionLeft.vue';
import donutRight from '@/components/donutSectionRight.vue';

// helper 
import Helper from '@/helpers/helper';

export default {
  name: 'Home',
  components: {
    'donut-left'  : donutLeft,
    'donut-right' : donutRight
  },
  computed : {
    /**
     * Flavors data
     */
    flavors() {
      return this.$store.state.flavors;
    }
  },
  methods : {
    /**
     * Check if number is odd or event
     */
    isOdd(number) {
      return Helper.checkOddEven(number, 'odd');
    }
  },
  /**
   * Run function before component rendered
   */
  beforeMount() {
    // get flavors
    this.$store.dispatch('getflavors');
  }
}
</script>
